import { StringConstantsMixin } from '../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

const {
  strings: {
    PRINT_PAGE: {
      PAPER_LETTER_IMPERIAL,
      PAPER_LEGAL_IMPERIAL,
      PAPER_TABLOID_IMPERIAL,
      PAPER_CUSTOM,
      ORIENTATION_PORTRAIT,
      ORIENTATION_LANDSCAPE,
      GRID_DECIMAL,
      NONE_OPTION,
      EXACT
    }
  }
} = StringConstantsMixin;

export const LETTER = 'letter';
export const LEGAL = 'legal';
export const TABLOID = 'tabloid';

export const A2 = 'a2';
export const A3 = 'a3';
export const A4 = 'a4';

export const CUSTOM = 'custom';

export const IMPERIAL_SIZES = [LETTER, LEGAL, TABLOID, CUSTOM];
export const METRIC_SIZES = [A2, A3, A4, CUSTOM];

export const PAPER_SIZE_LABELS = {
  [LETTER]: PAPER_LETTER_IMPERIAL,
  [LEGAL]: PAPER_LEGAL_IMPERIAL,
  [TABLOID]: PAPER_TABLOID_IMPERIAL,
  [A2]: 'A2',
  [A3]: 'A3',
  [A4]: 'A4',
  [CUSTOM]: PAPER_CUSTOM
};

export const DIMENSIONS = {
  [LETTER]: [8.5, 11],
  [LEGAL]: [8.5, 14],
  [TABLOID]: [11, 17],
  [A2]: [16.5, 23.2],
  [A3]: [11.7, 16.5],
  [A4]: [8.3, 11.7],
  [CUSTOM]: [16, 16]
};

export const PORTRAIT = 'portrait';
export const LANDSCAPE = 'landscape';

export const ORIENTATION_LABELS = {
  [PORTRAIT]: ORIENTATION_PORTRAIT,
  [LANDSCAPE]: ORIENTATION_LANDSCAPE
};

export const DECIMAL = 'decimal';
export const DMS = 'dms';
export const UTM = 'utm';
export const NONE = 'none';

export const GRID_LABELS = {
  [DECIMAL]: GRID_DECIMAL,
  [DMS]: 'D°M’S”',
  [UTM]: 'UTM',
  [NONE]: NONE_OPTION
};

export const SCALES = {
  // # 19: '1:1k',
  '18': '1:2k',
  '17': '1:4k',
  '-5': `1:5k ${EXACT}`,
  '16': '1:9k',
  '-6': `1:10k ${EXACT}`,
  '15': '1:18k',
  '-1': `1:24k ${EXACT}`,
  '-2': `1:25k ${EXACT}`,
  '14': '1:36k',
  '-3': `1:50k ${EXACT}`,
  '13': '1:72k',
  '-4': `1:100k ${EXACT}`,
  '12': '1:144k',
  '11': '1:289k',
  '10': '1:578k',
  '9': '1:1m',
  '8': '1:2m',
  '7': '1:5m',
  '6': '1:9m',
  '5': '1:18m',
  '4': '1:37m',
  '3': '1:74m',
  '2': '1:148m'
  // # 1:  '1:296m',
};
